import { useTranslation } from "react-i18next";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Stack, StackProps } from "@mui/material";
import DateTimeUtils from "../../utils/dateTimeUtils";

export const DateTime: React.FC<StackProps & { timestamp?: number }> = ({
  timestamp,
  ...stackProps
}) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  if (!timestamp) return;
  const date = DateTimeUtils.formatDate(timestamp, currentLanguage);
  const time = DateTimeUtils.formatTime(timestamp, currentLanguage);
  return (
    <Stack alignItems="center" direction="row" spacing={0.75} {...stackProps}>
      <span>{date}</span>
      <AccessTimeIcon
        fontSize="inherit"
        sx={{ color: "inherit", lineHeight: 0 }}
      />
      <span>{time}</span>
    </Stack>
  );
};
